app.service('callback',function($global, console){ 
	var list=[];
	function add(name,task){
		list[name]=task;
	}
	function getList(){
		console.log(list);
	}
	function run(name,params){
		try{
			eval(name(params));
			console.log('CALLBACK run: '+name);
		}catch(e){
			if(typeof list[name] != "undefined"){
				list[name](params);
				console.log('CALLBACK run: '+name);
			}
		}
	}
	add('addToCardSuccess',function(data){
		euro.logAddToCardSuccessEvent(data);
	});
	$global('addCallback',add);
	return {
		add:add,
		run:run,
		list:getList
	};
});